module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAA10lEQVR4AXSOvQ7BYBhG20YMRGKTMLsAg91oMEm4AOzCIDG7ALGYTF0YDGZuwAXYjMKKhUTC5zxNWsFXeU+f9+dE6xljDlADz4n56VDg5kMbMUn+lSSXbRbGMETMkF8lSQuJaZoBTBFzZFShFC5SNE2YIRbJoH4lLfVdVZo5Yhk8m8TdSfAowRIqcRI3R7c8TV8Naa0H2w304qQbxwV0XNfd26Qrxwl0EU5k8F6lMDzO0IMRwoUMKvynF9MRWuAj3MmoJD2ZdtDguALNjJ+StGasc9yS1noDAAD//y20RYIAAAAGSURBVAMAWk848i04YZ4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/customer2.png
// module id = OmFd
// module chunks = 0